$(document).ready(function() {

  
  window.setTimeout(function(){
    $('.popup-container').addClass('active');
  }, 1500)


  $('.popup-container .close').click(function(){
    $('.popup-container').removeClass('active');
  })

  gsap.registerPlugin(ScrollTrigger)

  // 1. Create a reusable function for quantity logic
  function adjustQuantity() {
    $('.popover__value-list input:checked').each(function() {
      let el = $(this).closest('label').find('span').first().text().toLowerCase();
      let $qtyBox = $('#quantity-box');

      if (el.includes('straw')) {
        $qtyBox.attr({ 'step': 10, 'min': 10 }).val(10);
      } else if (el.includes('embryo')) {
        $qtyBox.attr({ 'step': 3, 'min': 3 }).val(3);
      } else {
        $qtyBox.attr({ 'step': 1, 'min': 1 }).val(1);
      }
    });
  }

  adjustQuantity();

  $('.buy-box form').on('change', adjustQuantity);

  $('.Faq__Item').click(function() {
    $(this).find('.Faq__AnswerWrapper').toggleClass('active');
  });

  setTimeout(function() {
    $('#home-hero').addClass('active');
  }, 500);

  $('a[href^="#"]:not([href="#"])').on('click', function(e) {
    const target = $(this).attr('href');
    const $targetElement = $(target);

    if ($targetElement.length) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $targetElement.offset().top
      }, 800);
    }
  });

  // 5. Slick Sliders
  $('.video-slider').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    arrows: true,
    centerMode: $(window).width() >= 981,
  });

  $('.foot-menu-box').click(function() {
     $(this).toggleClass('active');
    $(this).find('ul, h3').first().toggleClass('active');
  });

  $('.filter-top .Collapsible__Button').click(function() {
    let $this = $(this);
    if ($this.hasClass('active')) {
      $('.filter-top .Collapsible__Inner, .filter-top .Collapsible__Button').removeClass('active');
    } else {
      $('.filter-top .Collapsible__Button, .filter-top .Collapsible__Inner').removeClass('active');
      $this.addClass('active');
      $this.closest('.filter-top').find('.Collapsible__Inner').addClass('active');
    }
  });

  $('#burger-icon').click(function(){
    $(this).toggleClass('active');
    $('#mega-nav-drop').toggleClass('active'); 
    $('#logo-dark').toggleClass('active');
    $('header .header').first().toggleClass('active');
  })

/*
  const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
*/
  
if($('#newsletter-callout').length >0){
  ScrollTrigger.create({
    trigger: "#newsletter-callout",
    start: "top 80%",
    onEnter: () => {
      document.querySelector("#newsletter-callout").classList.add("active");
      $('#newsletter-callout .newsletter-image').addClass('active');
      setTimeout(function(){
        $('#newsletter-callout .stacked-image').addClass('active');
      }, 400)
    },
  })
}
if($('#our-team').length >0){
  ScrollTrigger.create({
    trigger: "#our-team",
    start: "top 80%",
    onEnter: () => {
      document.querySelector("#our-team").classList.add("active");

    },
  })
}



const time = new Date().toLocaleTimeString("en-US", {
  timeZone: "America/Chicago",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true
});

$('#current-time').text(`${time}`);

AOS.init();

}); 